import { FunctionComponent } from "react";
import { Container } from "../../../../../components/formulario/styled";
import HeaderEventsBatismo from "./header";
import TabelaListaEventosBatismo from "./tabela";


interface ContainerEventsBatismoProps {

}

const ContainerEventsBatismo: FunctionComponent<ContainerEventsBatismoProps> = () => {
  return ( <>
    <Container>
      <HeaderEventsBatismo/>
      <TabelaListaEventosBatismo/>
    </Container>
  </> );
}

export default ContainerEventsBatismo;
